import React, {useEffect, useMemo, useState} from "react";
import {DAILY_CHECK_REPORT_LIST_HEADER} from "../../../../components/table/header/Headers";
import Search from "../../../../components/search/Search";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {removeDailyCheckReport} from "../../../../api/evaluation/DailyCheckReportService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

function DailyCheckReportListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: DAILY_CHECK_REPORT_LIST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, DAILY_CHECK_REPORT_LIST_HEADER, setHeader, [], () => {}, () => {}, 'daily_check_report');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "일일점검 상세"),
            url: `/evaluation/dailyCheck/${id}`,
        });
    };

    const deleteDailyCheck = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 일일체크현황을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeDailyCheckReport({ids}).then((response) => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
                refresh();
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
    };

    const dailyCheckJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'daily_check_report'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} size date={searchDate} detail pageInfo={pageInfo}>
                <SearchSection>
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'dailyCheckCode', extractObject(saveConditions), value)}
                                 data={saveConditions.dailyCheckCode}
                                 uniqueKey={'dailyCheckCode'}
                                 entity={"dailyCheck"} title={"일일체크코드"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"일일체크코드명"} />
                    </Selector>
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={dailyCheckJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {daily_check_report: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'daily_check_report')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="ExcelDailyCheckReportDto" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteDailyCheck}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 일일체크현황을 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/evaluation/dailyCheck/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export {DailyCheckReportListType};
